import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { FormButtons, renderers } from '../../components'
import { TicketService } from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch } from 'react-redux'

let TicketAssignmentForm = ({
  ticket,
  handleSubmit,
  pristine,
  reset,
  submitting,
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col xs={12}>
          <Field
            label="Assign To"
            name="currently_assigned_to"
            component={renderers.renderHiddenField}
            type="text"
          />
          <Field
            label="Assign To "
            name="currently_assigned_to_suggestions"
            renderSuggestion={(user) => {
              return (
                <ReactBootstrap.Col>
                  <h5>{user.first_name + ' ' + user.last_name}</h5>
                  <h6>{user.email}</h6>
                </ReactBootstrap.Col>
              )
            }}
            endpoint="users"
            actualFieldName="currently_assigned_to"
            initialValue={ticket.currently_assigned_to_name}
            component={renderers.EaseOnAutoSuggest}
            type="text"
          />
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}
TicketAssignmentForm = reduxForm({
  form: 'ticket-assignment-form',
})(TicketAssignmentForm)
export const UpdateTicketAssignment = (props) => {
  const { ticket, onTicketUpdate } = props
  const dispatch = useDispatch()
  const handleTicketAssignmentUpdate = (values) => {
    const service = new TicketService(ticket.url)
    service
      .makePatchRequest(values)
      .then((response) => {
        dispatch(
          showSuccessToast(
            'Success',
            `Ticket has been assigned to ${response.currently_assigned_to_name} .`
          )
        )
        onTicketUpdate(ticket)
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      })
  }
  const TicketAssignmentFormWithData = connect(() => ({
    initialValues: { status: ticket.status },
  }))(TicketAssignmentForm)
  return (
    <div>
      <TicketAssignmentFormWithData
        onSubmit={handleTicketAssignmentUpdate}
        ticket={ticket}
      />
    </div>
  )
}
